// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"638":"51ee798a","703":"5e5b4c22","968":"5f2b309d"}[chunkId] + ".chunk.js";
};